import React, {useContext, useEffect, useState, useCallback} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';

import NotificacionFormPartial from '../components/partials/NotificacionFormPartial';

const NotificacionForm = () => {
  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)

  let { id } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const updatedNotificacion = () => {
    console.log("Actualizado")
  }

  return (
    <div>
      {/* <h1>Notificación</h1> */}
      {renderHTML && (
        <>
        <h1>Notificación <BotonVolver /></h1>
        <NotificacionFormPartial id={id} updatedNotificacion={updatedNotificacion} />
        </>
      )}
    </div>
  );
};

export default NotificacionForm;